import BodySectionRichText from './BodySectionRichText';
export default BodySectionRichText;
